/* eslint-disable @typescript-eslint/no-explicit-any */
import { color } from 'asserts/styles/colors';

const useAddBiggerDoughnut = () => {
  const getBiggerEffect = (chart: any) => {
    const selectedTab = chart.config.options.activeTab;
    const biggerCount = [75];
    biggerCount.forEach((thickness: any) => {
      chart.getDatasetMeta(0).data[selectedTab].outerRadius = thickness;
      chart.chartArea.width;
    });

    chart.getDatasetMeta(0).data[selectedTab].options.borderColor =
      `${color.white}`;
    chart.getDatasetMeta(0).data[selectedTab].options.borderWidth = 2;
  };

  return getBiggerEffect;
};

export default useAddBiggerDoughnut;
